import { cn } from '@/app/lib/utils/tailwindcss';

interface ChipFilterItemProps {
  label: string;
  isSelected: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export default function ChipFilterItem({ label, isSelected, disabled, onClick }: ChipFilterItemProps) {
  return (
    <button
      type="button"
      role="option"
      aria-selected={isSelected}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50',
        'h-8 shrink-0 rounded-full border px-4 transition-colors',
        disabled && 'typo-body-5 cursor-not-allowed border-filter-chip-disabled-border bg-filter-chip-disabled-bg text-filter-chip-disabled-text',
        !disabled && isSelected && 'typo-body-4 cursor-default border-filter-chip-focused-border bg-filter-chip-focused-bg text-filter-chip-focused-text',
        !disabled && !isSelected && 'typo-body-5 cursor-pointer border-filter-chip-default-border bg-filter-chip-default-bg text-filter-chip-default-text',
      )}
    >
      {label}
    </button>
  );
}
